// 产品矩阵系统 - 布局组件
import React from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { Grid3X3, Package, ArrowLeft, Compass } from 'lucide-react';
import { PosterApp } from './index';

const navItems = [
  { path: '/poster', label: '画布编辑', icon: Grid3X3, exact: true },
  { path: '/poster/products', label: '产品管理', icon: Package },
  { path: '/poster/wizard', label: '选型向导', icon: Compass },
];

export function PosterLayout() {
  const location = useLocation();

  return (
    <PosterApp>
      <div className="min-h-screen bg-gray-50">
        {/* Top Navigation for Poster System */}
        <nav className="bg-white border-b border-gray-200 px-4 py-2">
          <div className="max-w-7xl mx-auto flex items-center justify-between">
            <div className="flex items-center gap-4">
              {/* Back to Admin */}
              <Link
                to="/uadmin"
                className="flex items-center gap-1 text-gray-500 hover:text-gray-700 text-sm"
              >
                <ArrowLeft className="w-4 h-4" />
                返回管理后台
              </Link>

              <div className="h-4 w-px bg-gray-300" />

              {/* Nav Items */}
              <div className="flex items-center gap-1">
                {navItems.map((item) => {
                  const isActive = item.exact
                    ? location.pathname === item.path
                    : location.pathname.startsWith(item.path);
                  const Icon = item.icon;

                  return (
                    <Link
                      key={item.path}
                      to={item.path}
                      className={`flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
                        isActive
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      }`}
                    >
                      <Icon className="w-4 h-4" />
                      {item.label}
                    </Link>
                  );
                })}
              </div>
            </div>
          </div>
        </nav>

        {/* Page Content */}
        <main>
          <Outlet />
        </main>
      </div>
    </PosterApp>
  );
}

export default PosterLayout;
